import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FilterStateService } from '@services/filter-state.service';
import { SearchInputComponent, SlideToggleComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';
import { IMainFiltersOpportunities } from '../opportunity-filters.config';

@Component({
    selector: 'app-opportunities-main-filters',
    templateUrl: './opportunities-main-filters.component.html',
    styleUrls: ['./opportunities-main-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SlideToggleComponent, SearchInputComponent]
})
export class OpportunitiesMainFiltersComponent implements OnInit, OnDestroy {
    mainFilters: IMainFiltersOpportunities = {};
    disabledClearFiltersBtn = false;

    private subscription?: Subscription;

    private readonly filterStateService = inject(FilterStateService<IMainFiltersOpportunities>);

    async ngOnInit(): Promise<void> {
        this.subscription = this.filterStateService.stateFilters$.subscribe(async (filters) => {
            if (!filters) {
                this.mainFilters = {} as IMainFiltersOpportunities;
            } else {
                this.mainFilters = filters as IMainFiltersOpportunities;
            }
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe();
    }

    async onFiltersChanged(): Promise<void> {
        this.filterStateService.updateMainFilters(this.mainFilters);
    }
}
